import { getDataDivisions } from "./methods/getDataDivisions";
import { checkIsRadio } from "./methods/checkIsRadio";
import { checkIsSelectBox } from "./methods/checkIsSelectBox";
import { checkIsAvailablePurchase } from "./methods/checkIsAvailablePurchase";

export default {
  getDataDivisions,
  checkIsRadio,
  checkIsSelectBox,
  checkIsAvailablePurchase,
};
